module.exports = __webpack_public_path__ + "img/oats_nso21006.1e1e8b80.jpg";